import axios from 'axios'
import settings from '../../settings'

const imdb = {
    namespaced: true,
    state: () => ({
        info:[]
      }),
      mutations:{
         updateImdbState(state,data){
             state.info=data;
         }
      },
      actions: {
        ImdbInfo({commit},imdbId){
            axios.get(`${settings.settings}/imdb/${imdbId}`).then(res => {
					commit('updateImdbState',res.data)
			 });
        },
      },
    
      getters: {
           
      }
}

export default imdb;

 